import { useCallback, useState } from 'react';
import { membersApi } from 'sectors/pilates/members/api/membersApi';

export function useMemberDebt(memberId) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [debtSummary, setDebtSummary] = useState(null);

  const fetchDebt = useCallback(async () => {
    if (!memberId) return;
    setLoading(true);
    setErr(null);
    try {
      const res = await membersApi.debt(memberId);
      setDebtSummary(res || null);
    } catch (e) {
      const msg =
        e?.message || e?.response?.data?.message || e?.response?.data || 'Borç bilgisi alınamadı';
      setErr(String(msg));
      setDebtSummary(null);
    } finally {
      setLoading(false);
    }
  }, [memberId]);

  return { loading, err, debtSummary, fetchDebt, setDebtSummary };
}
